// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"E4-z","dimensionLabel":"F4-z","styleChooserControlWrapper":"G4-z","styleChooserControl":"H4-z","disabled":"I4-z","giftCard":"J4-z","styleChooserText":"K4-z"};